import { render, staticRenderFns } from "./FreeDelivery.vue?vue&type=template&id=bea529ba&scoped=true&"
import script from "./FreeDelivery.vue?vue&type=script&lang=js&"
export * from "./FreeDelivery.vue?vue&type=script&lang=js&"
import style0 from "./FreeDelivery.vue?vue&type=style&index=0&id=bea529ba&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea529ba",
  null
  
)

export default component.exports